<script>
    import Section from "../controls/Section.svelte";
    import DashboardMessage from "../views/DashboardMessage.svelte";
  
    let messages = [
      {
        id: 1,
        type: "info",
        icon: "ℹ️",
        title: "Welcome to the platform!",
        content: "Thank you for joining. Explore our features to make the most out of your account.",
        datetime: "2025-01-13 10:30 AM",
        isUnread: true,
        callToAction: "Learn More",
      },
      {
        id: 2,
        type: "support",
        icon: "🛠️",
        title: "Support Ticket #12345",
        content: "Your ticket has been updated. Please review the latest response.",
        datetime: "2025-01-12 3:45 PM",
        isUnread: false,
        reply: true,
      },
      {
        id: 3,
        type: "milestone",
        icon: "🎉",
        title: "Milestone Achieved!",
        content: "Congratulations on reaching 100 completed tasks!",
        datetime: "2025-01-11 8:20 AM",
        isUnread: true,
      },
    ];
  
    let currentPage = 1;
    const messagesPerPage = 10;
  
    function paginateMessages() {
      const sortedMessages = [...messages].sort(
        (a, b) => new Date(b.datetime) - new Date(a.datetime)
      );
      const startIndex = (currentPage - 1) * messagesPerPage;
      const endIndex = startIndex + messagesPerPage;
      return sortedMessages.slice(startIndex, endIndex);
    }
  
    function nextPage() {
      if (currentPage * messagesPerPage < messages.length) currentPage++;
    }
  
    function previousPage() {
      if (currentPage > 1) currentPage--;
    }
  
    function handleCallToAction(id) {
      console.log(`Call to action triggered for message ID: ${id}`);
    }
  
    function handleReply(id) {
      console.log(`Reply triggered for message ID: ${id}`);
    }
  </script>
  
  <div class="space-y-8 text-left">
    <!-- Inbox Section -->
    <Section title="Inbox" subtitle="Your notification center">
      <div class="space-y-4">
        {#each paginateMessages() as message (message.id)}
          <DashboardMessage
            icon={message.icon}
            title={message.title}
            content={message.content}
            datetime={message.datetime}
            isUnread={message.isUnread}
            callToAction={message.callToAction}
            onCallToAction={() => handleCallToAction(message.id)}
            reply={message.reply}
            onReply={() => handleReply(message.id)}
          />
        {/each}
      </div>
      <!-- Pagination -->
      <div class="flex justify-between items-center mt-4">
        <button
          class="px-4 py-2 rounded"
          style="background-color: var(--app-background-color); color: var(--app-text-color);"
          on:click={previousPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button
          class="px-4 py-2 rounded"
          style="background-color: var(--app-background-color); color: var(--app-text-color);"
          on:click={nextPage}
          disabled={currentPage * messagesPerPage >= messages.length}
        >
          Next
        </button>
      </div>
    </Section>
  </div>
  